const Gear = ({ radius, teeth, color }) => {
  const points = [];
  for (let i = 0; i < teeth; i++) {
    const angle = (i * (360 / teeth) * Math.PI) / 180;
    const x1 = 100 + (radius - 5) * Math.cos(angle);
    const y1 = 100 + (radius - 5) * Math.sin(angle);
    const x2 = 100 + (radius + 5) * Math.cos(angle);
    const y2 = 100 + (radius + 5) * Math.sin(angle);
    points.push({ x1, y1, x2, y2 });
  }
  return (
    <svg viewBox="0 0 200 200" style={{ width: "100%", height: "100%" }}>
      <circle
        cx="100"
        cy="100"
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth="3"
        opacity="0.3"
      />
      {points.map((point, i) => (
        <line
          key={i}
          x1={point.x1}
          y1={point.y1}
          x2={point.x2}
          y2={point.y2}
          stroke={color}
          strokeWidth={radius > 70 ? 4 : 5}
          strokeLinecap="round"
          opacity={radius > 70 ? 0.6 : 0.7}
        />
      ))}
    </svg>
  );
};

export default Gear;
